<!-- No need to show the header while logging out. It also queries the IndexedDB (synchronization status), which the logout deletes. -->
@if (!outlet.activatedRouteData['hideHeader']) {
  <app-header />
}
<app-firebase-messaging-handler />
<app-unsupported-browser />

<!-- px-0 is required to use full width on mobile -->
<div class="zn-container px-0">
  <router-outlet #outlet="outlet"></router-outlet>
</div>